(function(global) {
  'use strict';

  function integerQuantity(value, config) {
    var quantity = typeof value === 'number' ? value : Number(String(value == null ? '' : value).trim());
    if (!Number.isFinite(quantity) || Math.floor(quantity) !== quantity) throw new Error('invalid_quantity');
    if (quantity < config.minQuantity || quantity > config.maxQuantity) throw new Error('quantity_out_of_range');
    return quantity;
  }

  function friendlyPriceCents(rawCents, lowerCents, upperCents) {
    var rounded = Math.round(rawCents);
    var base = Math.floor(rounded / 100) * 100;
    var candidates = [];
    [-100, 0, 100].forEach(function(offset) {
      candidates.push(base + offset + 49, base + offset + 99);
    });
    candidates = candidates.filter(function(candidate) {
      return candidate >= lowerCents && candidate <= upperCents;
    }).sort(function(left, right) {
      return Math.abs(left - rawCents) - Math.abs(right - rawCents) || left - right;
    });
    return candidates.length ? candidates[0] : rounded;
  }

  function servicePriceCents(serviceType, config, anchor) {
    var explicitLikePrice = Number(anchor && anchor.likePriceCents);
    if (serviceType === 'likes' && Number.isFinite(explicitLikePrice)) return explicitLikePrice;
    return Math.floor(Number(anchor.priceCents) / Number(config.servicePriceDivisors[serviceType] || 1));
  }

  function priceCents(quantity, config, serviceType) {
    var exact = config.anchors.find(function(anchor) { return anchor.quantity === quantity; });
    var upperIndex;
    var lower;
    var upper;
    var progress;
    var rawCents;
    if (exact) return servicePriceCents(serviceType, config, exact);
    upperIndex = config.anchors.findIndex(function(anchor) { return anchor.quantity > quantity; });
    if (upperIndex <= 0) throw new Error('price_unavailable');
    lower = config.anchors[upperIndex - 1];
    upper = config.anchors[upperIndex];
    progress = (quantity - lower.quantity) / (upper.quantity - lower.quantity);
    lower = { quantity: lower.quantity, priceCents: servicePriceCents(serviceType, config, lower) };
    upper = { quantity: upper.quantity, priceCents: servicePriceCents(serviceType, config, upper) };
    rawCents = lower.priceCents + progress * (upper.priceCents - lower.priceCents);
    return friendlyPriceCents(rawCents, lower.priceCents, upper.priceCents);
  }

  function range(configRanges, quantity) {
    return configRanges.find(function(item) { return quantity >= item.min && quantity <= item.max; });
  }

  function calculate(config, serviceType, inputQuantity) {
    var quantity = integerQuantity(inputQuantity, config);
    var service = String(serviceType || '').toLowerCase();
    var finalPriceCents;
    var baseReferencePriceCents;
    var nextAnchor;
    var nextUpsellPriceCents;
    if (service !== 'followers' && service !== 'likes') throw new Error('invalid_service');
    finalPriceCents = priceCents(quantity, config, service);
    baseReferencePriceCents = (quantity / 10) * servicePriceCents(service, config, config.anchors[0]);
    nextAnchor = config.anchors.find(function(anchor) { return anchor.quantity > quantity; }) || null;
    nextUpsellPriceCents = nextAnchor ? priceCents(nextAnchor.quantity, config, service) : null;
    return {
      priceVersion: config.priceVersion,
      serviceType: service,
      quantity: quantity,
      finalPriceCents: finalPriceCents,
      finalPrice: (finalPriceCents / 100).toFixed(2),
      currency: 'RON',
      baseReferencePriceCents: baseReferencePriceCents,
      discountPercent: Math.max(0, Math.round((1 - finalPriceCents / baseReferencePriceCents) * 100)),
      badge: range(config.badges, quantity).label,
      tier: range(config.visualTiers, quantity).value,
      rocketCost: service === 'likes' ? quantity * 5 : quantity,
      nextUpsellQuantity: nextAnchor ? nextAnchor.quantity : null,
      nextUpsellPriceCents: nextUpsellPriceCents,
      upsellDifferenceCents: nextUpsellPriceCents == null ? null : nextUpsellPriceCents - finalPriceCents,
      upsellExtraQuantity: nextAnchor ? nextAnchor.quantity - quantity : null
    };
  }

  global.FaimaDynamicPricing = { calculate: calculate };
})(window);
